.at{flex-shrink:0;}